module.exports = __webpack_public_path__ + "assets/download-520c0d09d6301f4c5f13ba4652a61284.svg";